import store from '@ps/store'
import _ from 'lodash'
import * as flow from './flow'
import { getContainerSize, getLayoutFromGraph } from './flow'
import {
  getPositionForNewSceneNode,
  layout,
  hideSceneEditor,
  showSceneEditor,
} from './layout'
import { getGraphData, getPorts } from './get-graph-data'
import config from './config'
import {
  getActionEventConfig,
  getTargetNodeAstConfig,
  makeAction,
  makeCondition,
  useEventIdToFindEventIndex,
} from '../visual-program/utils'
import nodePool from '../../../bridge/qc/node-pool'
import { Message } from 'element-ui'
import { addEdge } from './edge'
import { isScene } from './utils'
import { addScene } from '@ps/store/workbench/storyboard/scene-node'
import { addDagNode } from '@ps/store/workbench/storyboard/dag-node'
import {
  executeAction,
  getSwitchToSingleViewAction,
  getSwitchToStoryBoardAction,
} from '@ps/workbench/undo-redo'
import { sleep } from '@ps/utils/tools'
import { getSwitchSceneEventData, isSwitchScene } from '@ps/bridge/qc/vp'
import {
  EventType,
  getVpConditionConf,
  VpMethods,
} from '@ps/bridge/qc/vp/config'

const adapterResolutions = ['pdef', 'ldef']

let graphInstance = null

const getInitState = () => {
  return {
    mode: config.modeTypes.singleScene, // single-scene：单场景视图；story：故事板视图
    isEditScene: false, // 是否是编辑模式，如果为 true，在故事板中只能调整事件连线，不可编辑场景数据
    currentSceneUuid: '', // 当前场景 id，与全局的当前场景同步
    currentX6Node: null,
    eventData: null,
    hoverX6Node: null,
    layout: {
      // 故事板画布整体的布局配置
      graph: {
        pdef: {
          tx: config.graph.tx,
          ty: config.graph.ty,
        },
        ldef: {
          tx: config.graph.tx,
          ty: config.graph.ty,
        },
      },
    },
  }
}

function hideFlow() {
  const ele = document.getElementById('story-flow')
  ele.style.opacity = '0'
  ele.style.zIndex = '-10'
}

function showFlow() {
  const ele = document.getElementById('story-flow')
  ele.style.opacity = '1'
  ele.style.zIndex = '1'
}

function moveSceneEditorToTargetScenePosition({ graph, node }) {
  const prop = node.getProp()
  const { options } = graph
  const { x, y } = options
  const scale = store.state.workspace.game.device.scale
  // 节点需要重新 scale
  // graph 的偏移值使用原始的值，因为它没有被缩放
  const offsetLeft = prop.position.x * scale + x
  const offsetTop = prop.position.y * scale + y
  const stage = document.querySelector('#scene-editor')
  stage.style.left = offsetLeft + 'px'
  stage.style.top = offsetTop + 'px'
}

function moveSceneEditorToTopLeft() {
  const stage = document.querySelector('#scene-editor')
  stage.style.left = 0
  stage.style.top = 0
}

function removeAllEdges() {
  const edges = graphInstance
    .getCells()
    .filter((cell) => cell.data.shape === config.nodeTypes.edge)
  edges && edges.forEach((node) => node.remove())
}

function removeTargetSceneDagNodes(sceneId) {
  const nodes = graphInstance
    .getCells()
    .filter(
      (cell) =>
        cell.data.shape === config.nodeTypes.node &&
        cell.data.sceneId === sceneId,
    )
  nodes && nodes.forEach((node) => node.remove())
}

export default {
  namespaced: true,

  state: getInitState(),

  getters: {
    isSingleScene(state) {
      return state.mode === config.modeTypes.singleScene
    },
  },

  mutations: {
    updateCurrentSceneUuid(state) {
      const node = store.state.workspace.sceneManager.currentSceneNode
      node && (state.currentSceneUuid = node.uuid)
    },

    updateCurrentX6Node(state, node) {
      state.currentX6Node = node
    },

    updateHoverX6Node(state, node) {
      state.hoverX6Node = node
    },

    updateEventData(state) {
      state.eventData = getSwitchSceneEventData()
      console.log(state.eventData)
    },

    updateGraphLayoutData(state, { tx, ty }) {
      const adapterResolution =
        store.state.workspace.game.device.adapterResolution
      const graph = state.layout.graph || {}
      if (_.isEmpty(graph[adapterResolution])) {
        graph[adapterResolution] = {}
      }
      graph[adapterResolution].tx = tx
      graph[adapterResolution].ty = ty
      state.layout.graph = graph
    },

    updateTargetNodeLayoutData(state, { id, x, y, resolution }) {
      const adapterResolution =
        resolution || store.state.workspace.game.device.adapterResolution
      if (_.isEmpty(state.layout[adapterResolution])) {
        state.layout[adapterResolution] = {}
      }
      state.layout[adapterResolution][id] = {
        ...state.layout[adapterResolution][id],
        id,
        x,
        y,
      }
    },

    initLayoutData(state, val) {
      state.layout = {
        ...val,
        // graph 有默认值
        graph: {
          ...state.layout.graph,
          ...val.graph,
        },
      }
    },

    // 删除时横竖屏的一起删除
    removeTargetNodeLayoutData(state, id) {
      adapterResolutions.forEach((item) => {
        if (state.layout[item]) {
          delete state.layout[item][id]
        }
      })
    },

    highlightEdge(state, { edge }) {
      edge.attr({
        line: {
          stroke: config.brandColor, // 指定 path 元素的填充色
        },
      })
    },

    moveNode(state, { id, x, y }) {
      if (state.mode === config.modeTypes.story && graphInstance) {
        // const node = graphInstance.getCellById(id)
        // debugger
      }
    },

    hideFlow(state) {
      hideFlow()
    },

    showFlow() {
      showFlow()
    },

    resize(state) {
      if (state.mode === config.modeTypes.story && graphInstance) {
        const { width, height } = getContainerSize()
        graphInstance.resize(width, height)
      }
    },

    moveSceneEditorToTargetScenePosition({ state }, { sceneId }) {
      const node = graphInstance.getCellById(sceneId)
      moveSceneEditorToTargetScenePosition({
        graph: graphInstance,
        node,
      })
    },
  },

  actions: {
    async switchQcScene({ state }, { sceneId, record = false }) {
      store.commit('workspace/lockPage')
      // 切换场景之前的清楚当前节点操作固定没有历史记录
      await store.dispatch('workspace/game/clearActiveNode', { record: false })
      await store.dispatch('workspace/game/sceneManager/switchScene', {
        uuid: sceneId,
        record,
      })
      // 故事板默认展示事件 tab
      store.commit('workspace/rightPane/updateTabBarList', ['scene', 'event'])
      store.commit('workspace/rightPane/updateActiveTab', 'event')
      store.commit('workspace/unlockPage')
    },

    async switchQcNode({ state }, { uuid, record = false }) {
      const qcNode = nodePool.find(uuid)
      await store.dispatch('workspace/game/updateActiveNode', {
        node: qcNode,
        record,
      })
      // 编辑模式与非编辑模式展示的 tab 不一样
      const tabList = state.isEditScene
        ? ['design', 'animation', 'event']
        : ['event']
      const tab = state.isEditScene ? 'design' : 'event'
      store.commit('workspace/rightPane/updateTabBarList', tabList)
      store.commit('workspace/rightPane/updateActiveTab', tab)
    },

    switchToStoryBoard({ commit, state, dispatch }) {
      state.mode = config.modeTypes.story
      dispatch('init')
      graphInstance.enablePanning()
      hideSceneEditor()
      // 故事板默认展示事件 tab
      store.commit('workspace/rightPane/updateTabBarList', ['event'])
      store.commit('workspace/rightPane/updateActiveTab', 'event')
      store.dispatch('workspace/stage/resizeStageByConfig', {
        width: 375,
        height: 667,
        showRuler: false,
        allowSnapping: false,
      })
    },
    switchToStoryBoardHistory({ state }, { record } = { record: true }) {
      return executeAction({
        action: getSwitchToStoryBoardAction(),
        record,
      })
    },

    switchToSingleView({ state, commit }) {
      state.mode = config.modeTypes.singleScene
      state.isEditScene = false
      state.eventData = null
      commit('updateCurrentX6Node', null)
      graphInstance.dispose()
      graphInstance = null
      showSceneEditor()
      moveSceneEditorToTopLeft()
      store.dispatch('workspace/game/device/updateScale', 1)
      store.dispatch('workspace/stage/resizeStageByConfig', {
        width: '100%',
        height: '100%',
        showRuler: true,
        allowSnapping: true,
      })
      store.dispatch('workspace/rightPane/switchToStageConfigTab', {
        activeTab: 'event',
      })
    },

    switchToSingleViewHistory({ state }, { record } = { record: true }) {
      return executeAction({
        action: getSwitchToSingleViewAction(),
        record,
      })
    },

    // 编辑故事板中的场景
    async editTargetScene({ state, dispatch, commit }, { sceneId }) {
      await dispatch('switchQcScene', { sceneId, record: false })
      state.isEditScene = true
      showSceneEditor()
      // 删除边
      removeAllEdges()
    },

    /**
     * 退出编辑模式，如果 sceneId 为空说明不需要选中特定的节点，则渲染所有的边
     * @param sceneId
     */
    async exitEditScene({ state, dispatch, commit }, { sceneId } = {}) {
      if (!sceneId) {
        throw new Error('场景 id 不能为空')
      }

      // 退出前先进行一次截图
      //  因为新加一个节点后不做其他操作就退出编辑时，通过watch currentSceneTree 去确认截图的时机，此时静态资源(如图片)可能没有加载完成
      await store.dispatch('workspace/sceneManager/getThumb')
      await store.dispatch('workspace/sceneManager/markSceneThumbnailDirty', {
        sceneId,
      })

      state.isEditScene = false
      graphInstance.enablePanning()
      hideSceneEditor()
    },

    async selectX6Node({ state, commit, dispatch }, { sceneId, id }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      // 跳转至 event tab 保证事件列表 UI 被更新（因为事件列表那里没有跟随数据更新）
      store.commit('workspace/rightPane/updateActiveTab', 'event')
      // 选中故事板中的节点
      const node = graphInstance.getCellById(id)
      graphInstance.select(node)
      commit('updateCurrentX6Node', node)
      commit('updateCurrentSceneUuid')
      if (node) {
        commit('moveSceneEditorToTargetScenePosition', { sceneId })
      }
    },

    /**
     * 选择故事板中的节点
     */
    async selectX6NodeAndRenderEdges(
      { state, commit, dispatch },
      { sceneId, id },
    ) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      dispatch('selectX6Node', { sceneId, id })
      dispatch('renderEdges', { sceneId, id })
    },

    async selectSceneNode({ state, dispatch, commit }, { sceneId }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      await dispatch('switchQcScene', {
        sceneId,
        record: true,
      })
    },

    async selectDagNode({ state, dispatch, commit }, { sceneId, id }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      await dispatch('switchQcScene', {
        sceneId,
        record: false,
      })
      await dispatch('switchQcNode', { uuid: id, record: true })
    },

    /**
     * 选择故事板节点并切换素材中的节点
     * @param sceneId 当前场景 id
     * @param id 当前节点 id，如果选中场景的话 sceneId 与 id 值一样
     * @returns {Promise<void>}
     */
    async selectNode({ state, dispatch }, { sceneId, id }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      if (!sceneId || !id) throw new Error('场景 id 与节点 id 都是必传参数')

      if (sceneId !== id) {
        dispatch('selectDagNode', { sceneId, id })
      } else {
        dispatch('selectSceneNode', { sceneId })
      }
    },

    zoomTo({ state, dispatch, commit }, val) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      graphInstance.zoomTo(val)
      if (state.currentSceneUuid) {
        commit('moveSceneEditorToTargetScenePosition', {
          sceneId: state.currentSceneUuid,
        })
      }
    },

    async changeOrientation({ state, dispatch }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      // sleep 500ms 是为了切换横竖屏的时候增加一个 loading 效果，保证 reInit 时渲染内容已完成
      store.commit('workspace/lockPage')
      hideFlow()
      // 在故事版中切换横竖屏 scale 保持不变
      const scale = store.state.workspace.game.device.scale
      await dispatch('reInit', { scale })
      // await sleep(200)
      store.commit('workspace/unlockPage')
      showFlow()
    },

    getLayoutFromGraph() {
      return getLayoutFromGraph({
        graph: graphInstance,
        adapterResolution: store.state.workspace.game.device.adapterResolution,
      })
    },

    async reInit({ dispatch, state }, { scale, tx, ty } = {}) {
      console.log('故事板重新初始化')
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      // 销毁并重新渲染
      graphInstance.dispose()
      await dispatch('init', { scale, tx, ty })
    },

    async init({ state, commit, dispatch }, { scale = 0.5, tx, ty } = {}) {
      if (state.mode !== config.modeTypes.story) return
      console.log('故事板初始化')
      commit('updateCurrentSceneUuid')
      commit('updateEventData')
      const { graph } = flow.init()
      graphInstance = graph
      // 从单场景切换到故事板，缩放比例改为 50%
      dispatch('zoomTo', scale)

      graphInstance.positionContent('top-left')
      const adapterResolution =
        store.state.workspace.game.device.adapterResolution
      graph.translate(
        tx || state.layout.graph[adapterResolution].tx * scale,
        ty || state.layout.graph[adapterResolution].ty * scale,
      )
      const scenes = graphInstance
        .getCells()
        .filter((cell) => isScene(cell.data.shape))
      scenes.forEach((scene) => {
        const position = scene.getPosition()
        commit('updateTargetNodeLayoutData', {
          id: scene.id,
          x: position.x,
          y: position.y,
        })
      })
    },

    reLayout({ state }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      console.log('故事板重新布局')
      layout({
        graph: graphInstance,
        sceneId: state.currentSceneUuid,
      })
    },

    async addSwitchSceneEvent(
      { state, dispatch },
      { edge, previousCell, currentCell },
    ) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return

      const sortArr = [
        EventType.click,
        EventType.hold,
        EventType.down,
        EventType.up,
        EventType.doubleClick,
        EventType.swipeUp,
        EventType.swipeDown,
        EventType.swipeLeft,
        EventType.swipeRight,
        EventType.swipeAny,
      ]
      const source = edge.getSourceCell()
      const target = currentCell
      const sourceNodeId = source.data.nodeId
      const sourceSceneId = source.data.sceneId
      const targetNodeId = target.data.nodeId
      const astConfig = getTargetNodeAstConfig(sourceNodeId)
      const eventList = astConfig.map((event) => {
        const eventType = event.condition[0].content
        const hasSwitchSceneAction = event.action.some((item) =>
          isSwitchScene(item.method),
        )
        return {
          eventType,
          event,
          hasSwitchSceneAction,
        }
      })
      // 排序
      // 按照顺序排列点击，长按3s，按下，抬起，双击，上滑，下滑，左滑，右滑，任意滑动顺序填充
      const sortedEventList = sortArr.map((eventType) => {
        return (
          eventList.find((item) => item.eventType === eventType) || {
            eventType,
            event: null,
            hasSwitchSceneAction: false,
          }
        )
      })
      const nextEventConfig = sortedEventList.find(
        (item) => !item.hasSwitchSceneAction,
      )
      if (nextEventConfig) {
        const conf = _.flatten(Object.values(getVpConditionConf())).find(
          (item) => item.command === nextEventConfig.eventType,
        )
        const condition = makeCondition({ uuid: sourceNodeId, conf })
        let nextEvent = nextEventConfig.event
        // 如果 condition, event 为空，需要增加 event 与 action
        // 如果 condition 不为空，则只需要增加 action
        if (_.isEmpty(nextEvent) || _.isEmpty(nextEvent.condition)) {
          nextEvent = await store.dispatch(
            'workspace/game/visualProgram/addEventItem',
            {
              condition,
              sceneId: sourceSceneId,
            },
          )
        }

        // 加工 action，这里的逻辑参考了 event-block 的旧代码，看起来有点奇怪，但是可以用
        const actionEventList = _.flatten(
          Object.values(
            store.state.workspace.game.visualProgram.actionEventListAll,
          ),
        )
        const actionEvent = actionEventList.find(
          (item) => item.method === VpMethods.vpSwitchScene,
        )
        const actionEventConfig = getActionEventConfig(
          actionEvent,
          store.state.workspace.game.visualProgram.actionEventListAll,
        )
        const action = makeAction({
          selectTarget: nodePool.find(sourceNodeId),
          actionEvent,
          actionEventConfig,
          actionParams: {
            jumpSceneId: nodePool.find(targetNodeId).uuid,
          },
        })
        const astIndex = useEventIdToFindEventIndex({
          id: nextEvent.id,
          sceneId: sourceSceneId,
        })

        // action 结构
        // id: "njjhA6M2fcwA094"
        // label: "跳转指定场景"
        // method: "vpSwitchScene"
        // node: "0f5e163f-2062-4cf9-8946-a7d1177589ac"
        // param: {jumpSceneId: "4f514adb-22aa-45f0-8c73-4ea6e37299cd"}
        // paramLabel: "jumpSceneId"
        // paramLabelUI: ""
        // properties: {jumpSceneId: {…}}
        // script: ""
        // target: false
        // targetLabel: "gf_0021_m8ta7xt4drwb586_aifyjhcxckzt739"

        await store.dispatch('workspace/game/visualProgram/addActionHistory', {
          astIndex,
          action,
          sceneId: sourceSceneId,
        })
        dispatch('renderEdges', { sceneId: sourceSceneId, id: sourceNodeId })
      } else {
        Message.error('跳转场景事件超过限制')
        edge.remove()
      }
    },

    async addSwitchSceneEventToTargetScene(
      { state, dispatch },
      { isNew, edge, previousCell, currentCell },
    ) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      if (isNew) {
        const source = edge.getSourceCell()
        const sourceData = _.cloneDeep(source.data)
        await dispatch('addSwitchSceneEvent', {
          edge,
          previousCell,
          currentCell,
        })
        // 连线后切换场景和节点（这样事件列表才展示出正确的信息）
        if (sourceData) {
          await store.dispatch('workspace/storyboard/selectNode', {
            sceneId: sourceData.sceneId,
            id: sourceData.nodeId,
          })
        }
        dispatch('renderDagNodes')
        dispatch('renderEdges')
      }
    },

    /**
     * 根据 ast 配置刷新边，如果节点 id 与场景 id 不为空，则渲染这些 id 相关的线。反之则渲染所有边
     * @param id 节点 id，当 id 与 sceneId 相同的时候说明选中的是场景节点
     * @param sceneId 场景 id
     */
    renderEdges({ state, dispatch, commit }, { id, sceneId } = {}) {
      // 编辑状态不可重新渲染
      if (
        state.mode !== config.modeTypes.story ||
        !graphInstance ||
        state.isEditScene
      ) {
        return
      }
      if ((sceneId && !id) || (!sceneId && id)) {
        throw new Error('场景 id 与节点 id 必须同时有值，或同时没有值')
      }

      removeAllEdges()
      let { edges } = getGraphData()
      if (id && sceneId) {
        // 如果 id 等于 sceneId 说明选中的是场景节点，将该场景的所有节点都显示出来，反之，则只展示当前节点的连线
        if (id === sceneId) {
          edges = edges.filter((edge) => edge.data.sceneId === sceneId)
        } else {
          edges = edges.filter((edge) => edge.data.nodeId === id)
        }
      }

      // 如果没有 id 和 sceneId，将当前事件数据清空
      if (!id && !sceneId) {
        store.commit('workspace/game/visualProgram/updateCurrentEventData', {
          actionIds: null,
          eventIds: null,
        })
      }

      // 刷新边时，必须保证边的起始节点和终点必须存在
      edges.forEach((metaData) => {
        const node = graphInstance.getCellById(metaData.source.cell)

        if (!node) {
          console.log('边的起始节点不存在')
          return
        }

        const edge = addEdge({
          graph: graphInstance,
          metaData,
        })
        // 如果当前边的 action 与现有的一致且有特定的节点 id 与场景 id，则高亮边
        if (
          _.isEqual(
            metaData.data.actionIds,
            store.state.workspace.game.visualProgram.currentEventData.actionIds,
          )
        ) {
          commit('highlightEdge', {
            edge,
          })
        }
      })
    },

    /**
     * 渲染当前场景节点的相关节点
     * 当场景的节点发生变化后，如新增了节点或移动了位置，就需要重新渲染
     */
    renderDagNodes({ state, dispatch }) {
      const sceneId = state.currentSceneUuid
      console.log('renderDagNodes', sceneId)
      // 编辑状态不可重新渲染
      if (
        state.mode !== config.modeTypes.story ||
        !graphInstance ||
        state.isEditScene
      ) {
        return
      }
      removeTargetSceneDagNodes(sceneId)
      const data = getGraphData()
      if (data && data.nodes) {
        const nodes = sceneId
          ? data.nodes.filter((metaData) => metaData.data.sceneId === sceneId)
          : data.nodes
        nodes.forEach((metaData) => {
          addDagNode({
            x: 0,
            y: 0,
            graph: graphInstance,
            metaData: metaData,
          })
        })
        // reLayout 一次保证布局正确
        dispatch('reLayout')
      }
    },

    async addScene({ state, commit, dispatch }, { qcNode }) {
      // 如果是单场景添加场景的话，检查当前分辨率下是否有 layout 数据，如果有 layout 数据说明故事板曾经被实例化过
      // 这个时候即使在单场景添加的场景，也需要添加布局数据
      // 如果没有 layout 数据，则不需要添加布局数据
      if (state.mode === config.modeTypes.singleScene) {
        adapterResolutions.forEach((item) => {
          if (_.isEmpty(state.layout[item])) return
          const { x, y } = getPositionForNewSceneNode({
            qcNode,
            resolution: item,
          })
          commit('updateTargetNodeLayoutData', {
            id: qcNode.uuid,
            x,
            y,
            resolution: item,
          })
        })
        return
      }

      console.log('add scene', qcNode)
      // 加 100ms 保证已完成切场景（为了横竖屏截图）的操作
      await sleep(100)
      const currentQcSceneNode =
        store.state.workspace.sceneManager.currentSceneNode
      const width = currentQcSceneNode.width
      const height = currentQcSceneNode.height
      const scene = addScene({
        graph: graphInstance,
        metaData: {
          id: qcNode.uuid,
          width: width / 2,
          height: height / 2,
          data: {
            sceneId: qcNode.uuid,
            nodeId: qcNode.uuid,
            switchSceneId: '',
            shape: config.nodeTypes.scene,
            nodeMovable: true,
            isSceneNode: true,
          },
          ports: getPorts({
            isSceneNode: true,
          }),
        },
      })
      adapterResolutions.forEach((item) => {
        if (_.isEmpty(state.layout[item])) return
        const { x, y } = getPositionForNewSceneNode({
          qcNode,
          resolution: item,
        })
        scene.position(x, y)
        commit('updateTargetNodeLayoutData', {
          id: scene.id,
          x,
          y,
          resolution: item,
        })
      })
      await dispatch('reInit')
      dispatch('moveViewToCurrentScene', {
        sceneId: scene.id,
      })
    },

    removeScene({ state, commit, dispatch }, { sceneId }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      console.log('remove scene', sceneId)
      const node = graphInstance.getCellById(sceneId)
      node.remove()
      commit('removeTargetNodeLayoutData', sceneId)
      commit('updateCurrentSceneUuid')
      dispatch('reInit')
    },

    moveNodeHistory({ state }, { x, y, id }) {
      // debugger
    },

    /**
     * 移动视图到当前场景，确保场景显示在用户面前
     */
    moveViewToCurrentScene({ state }, { sceneId }) {
      if (state.mode !== config.modeTypes.story || !graphInstance) return
      const node = graphInstance.getCellById(sceneId)
      graphInstance.translate(
        config.graph.tx - node.position().x * graphInstance.zoom(),
        config.graph.ty - node.position().y * graphInstance.zoom(),
      )
    },
  },
}
